import { BrowserModule, TransferState } from '@angular/platform-browser';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { app_routing } from './app.routing';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonThemeModule, RavenErrorHandler } from './common-theme/index';

// Material
import {
  MatInputModule,
  MatDialogModule,
  MatSelectModule,
  MatTooltipModule,
  MatTabsModule,
  MatButtonModule,
  MatSnackBarModule
} from '@angular/material';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { exportTranslateStaticLoader } from './common-theme/i18n/translate-browser-loader.service';

// Components
import { AppComponent } from './app.component';
import { ExpandableContactFormComponent } from './shared/expandable-contact-form/expandable-contact-form.component';
import { ExpandableContactFormMobileComponent } from './shared/expandable-contact-form/expandable-contact-form-mobile.component';
import { TestimonialsCarouselComponent } from './shared/testimonials-carousel/testimonials-carousel.component';
import { HomeComponent } from './home/home.component';
import { PartnersComponent } from './partners/partners.component';
import { ServicesComponent } from './services/services.component';
import { HousesRouterComponent } from './houses/houses-router.component';
import { HousesComponent } from './houses/houses.component';
import { HouseDetailsComponent } from './houses/house-details.component';
import { ApartmentSearchComponent } from './shared/apartment-search/apartment-search.component';
import { MyApartmentTypeComponent } from './shared/my-apartment-type/my-apartment-type.component';
import { ContactComponent } from './contact/contact.component';
import { FloorsComponent } from './floors/floors.component';
import { BuildingsRouterComponent } from './buildings/buildings-router.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { GalleryPageComponent } from './gallery-page/gallery-page.component';
import { ApartmentTypeDetailsComponent } from './houses/apartment-type-details.component';
import { BeforeAfterComparisonComponent } from './shared/before-after-comparison/before-after-comparison.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ParkingComponent } from './parking/parking.component';

import { LocalisationComponent } from './localisation/localisation.component';
import { InterfaceComponent } from './localisation/interface.component';
import { GmapComponent } from './localisation/gmap.component';

import { AboutUsComponent } from './about-us/about-us.component';
import { FacilitiesComponent } from './about-us/facilities.component';
import { HistoryComponent } from './about-us/history.component';
import { ProjectComponent } from './about-us/project.component';
import { FinishesComponent } from './about-us/finishes.component';
import { MenuContainerComponent } from './shared/menu-container/menu-container.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    FacilitiesComponent,
    HistoryComponent,
    ServicesComponent,
    HousesRouterComponent,
    HousesComponent,
    ApartmentSearchComponent,
    ContactComponent,
    FloorsComponent,
    BuildingsRouterComponent,
    BuildingsComponent,
    GalleryPageComponent,
    HouseDetailsComponent,
    MenuContainerComponent,
    PartnersComponent,
    TestimonialsCarouselComponent,
    ExpandableContactFormComponent,
    ExpandableContactFormMobileComponent,
    MyApartmentTypeComponent,
    ApartmentTypeDetailsComponent,
    BeforeAfterComparisonComponent,
    FooterComponent,
    ParkingComponent,
    LocalisationComponent,
    InterfaceComponent,
    GmapComponent,
    ProjectComponent,
    FinishesComponent
  ],
  imports: [
    CommonThemeModule,
    BrowserModule.withServerTransition({ appId: 'theme7' }),
    TransferHttpCacheModule,
    FormsModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDqK0aUZbZtx31c8Ic6qQOCLctffxhG4Dk',
      libraries: ['places']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: exportTranslateStaticLoader,
        deps: [HttpClient, TransferState]
      }
    }),
    HttpClientModule,
    app_routing,
    ScrollToModule.forRoot(),

    // Material
    MatSnackBarModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts